import request from "@/util/request";

// 头部nav
export function getScreenV2Hometbzb(data) {
  return request({
    url: "/api/restful/getScreenV2Hometbzb",
    method: "get",
    params: data
  });
}
// 智慧物联顶部指标
export function getWlwHeadData() {
  return request({
    url: "/api/restful/getWlwHeadData",
    method: "get"
  });
}
// 查询园区产值年份
export function getScreenV2DataProcessGetYear(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessGetYear",
    method: "get",
    params: data
  });
}
//根据年份查询各类型企业数量
export function getScreenV2DataProcessGetCompanyNum(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessGetCompanyNum",
    method: "get",
    params: data
  });
}
//根据年份查询各产业园产值
export function getScreenV2DataProcessGetCyyzcz(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessGetCyyzcz",
    method: "get",
    params: data
  });
}
//园区产值
export function getScreenV2DataProcessGetCyyczQxcz(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessGetCyyczQxcz",
    method: "get",
    params: data
  });
}
//产业园产值情况
export function getScreenV2DataProcessGetCyycz(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessGetCyycz",
    method: "get",
    params: data
  });
}
//科技成果
export function getScreenV2DataProcessNew(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessNew",
    method: "get",
    params: data
  });
}
//科技成果
export function getScreenV2DataNewProcess(data) {
  return request({
    url: "/api/restful/getScreenV2DataNewProcess",
    method: "get",
    params: data
  });
}
//产品销售额
export function getScreenV2DataProcessGetCpxse(data) {
  return request({
    url: "/api/restful/getScreenV2DataProcessGetCpxse",
    method: "get",
    params: data
  });
}
//园区大事记
export function findWebsiteNewsByYear(data) {
  return request({
    url: "/api/restful/findWebsiteNewsByYear",
    method: "get",
    params: data
  });
}
//品牌产品
export function getOrgCompanyProducts(data) {
  return request({
    url: "/api/restful/getOrgCompanyProducts",
    method: "get",
    params: data
  });
}
//养殖规模
export function getDataYzgm(data) {
  return request({
    url: "/api/restful/getDataYzgm",
    method: "get",
    params: data
  });
}
//根绝位置编码查询指标
export function getScreenV2ByPositionCodeGetIndex(data) {
  return request({
    url: "/api/restful/getScreenV2ByPositionCodeGetIndex",
    method: "get",
    params: data
  });
}
//根据指标id查询图层
export function getScreenV2ByIndexIdGetLayer(data) {
  return request({
    url: "/api/restful/getScreenV2ByIndexIdGetLayer",
    method: "get",
    params: data
  });
}
//首页建设项目进度条
export function getScreenV2XmGetWorl(data) {
  return request({
    url: "/api/restful/getScreenV2XmGetWorl",
    method: "get",
    params: data
  });
}
//首页项目建设分类
export function getScreenV2XMTJ(data) {
  return request({
    url: "/api/restful/getScreenV2XMTJ",
    method: "get",
    params: data
  });
}
//首页水质检测
export function getWlwWaterDataNowAll(data) {
  return request({
    url: "/api/restful/getWlwWaterDataNowAll",
    method: "get",
    params: data
  });
}
//首页天气
export function getCodeByJwd(data) {
  return request({
    url: "/api/restful/getCodeByJwd",
    method: "get",
    params: data
  });
}
//首页预警
export function getScreenV2FindWlwWarningByCategoryAndDateNum(data) {
  return request({
    url: "/api/restful/getScreenV2FindWlwWarningByCategoryAndDateNum",
    method: "get",
    params: data
  });
}

//首页预警
export function getWlwWarningData(data) {
  return request({
    url: "/api/restful/getWlwWarningData",
    method: "get",
    params: data
  });
}

//气象站
export function findQxzWlwnNwestData() {
  return request({
    url: "/api/restful/findQxzWlwnNwestData?deviceId=CJ02A-2010271",
    method: "get"
    // params: data
  });
}

// 右上角预警
export function getNewWarningByCategory(data) {
  return request({
    url: "/api/restful/getNewWarningByCategory",
    method: "get",
    params: data
  });
}
